import React from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Box, Skeleton, Typography, Paper } from "@mui/material";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const OrderVolumeChart = ({ data, isLoading, error }) => {
  if (error) {
    return <Typography color="error">{error}</Typography>;
  }

  if (isLoading || !data) {
    return (
      <Skeleton
        variant="rectangular"
        height={300}
      />
    );
  }

  if (!data || data.length === 0) {
    return (
      <Box
        sx={{
          height: 300,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography color="textSecondary">No data available</Typography>
      </Box>
    );
  }

  // Transform data for chart
  const chartData = {
    labels: data.map((item) => item._id),
    datasets: [
      {
        label: "Orders",
        data: data.map((item) => item.count),
        borderColor: "#8884d8",
        backgroundColor: "rgba(136, 132, 216, 0.5)",
        yAxisID: "y",
        tension: 0.4,
      },
      {
        label: "Value ($)",
        data: data.map((item) => item.value),
        borderColor: "#82ca9d",
        backgroundColor: "rgba(130, 202, 157, 0.5)",
        yAxisID: "y1",
        tension: 0.4,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: "index",
      intersect: false,
    },
    plugins: {
      legend: {
        display: true,
        position: "top",
      },
      title: {
        display: true,
        text: "Order Volume Trend",
      },
    },
    scales: {
      y: {
        type: "linear",
        display: true,
        position: "left",
        title: {
          display: true,
          text: "Orders",
        },
      },
      y1: {
        type: "linear",
        display: true,
        position: "right",
        title: {
          display: true,
          text: "Value ($)",
        },
        grid: {
          drawOnChartArea: false,
        },
      },
    },
  };

  return (
    <Paper sx={{ p: 2, height: 400 }}>
      <Line
        data={chartData}
        options={options}
      />
    </Paper>
  );
};

export default OrderVolumeChart;
